import { useMemo } from 'react';
import { useMutation } from '@tanstack/react-query';

import { API } from 'core/API';

import {
	AdminSearchRequest,
	ADMIN_SEARCH_FILTER_TYPE,
	ISearchOpportunitiesSort,
} from '@joc/api-gateway/lib/api-client';

import { buildAdminSearchRequest, SuperAdminOpportunitiesFilters, SuperAdminOpportunitiesState } from '../mappers';

export const useExportSuperAdminOpportunities = ({
	opportunityFilterType,
	search,
	sort,
	filters,
}: {
	opportunityFilterType: ADMIN_SEARCH_FILTER_TYPE;
	search?: string;
	sort?: ISearchOpportunitiesSort;
	filters?: SuperAdminOpportunitiesFilters;
}) => {
	const exportBody: AdminSearchRequest = useMemo(
		() =>
			buildAdminSearchRequest({
				opportunityFilterType,
				state: { search, sort, filters } as SuperAdminOpportunitiesState,
			}),
		[opportunityFilterType, search, sort, filters]
	);

	return useMutation<void, unknown, void>({
		mutationFn: async () => API.exportAdminOpportunities(undefined, exportBody),
	});
};
